<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ $tc('remove_permission') }}?
        </v-card-title>
        <v-card-text>
          {{ $t('confirm_permission_delete') }}
          <strong>{{ name }}</strong>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="text_red" text @click.native="closeModal">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn color="green darken-1" text @click.native="deletePermission">
            {{ $t('confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: false,
      default: () => null
    },
    open: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data () {
    return {
      dialog: this.open
    }
  },
  methods: {
    closeModal () {
      this.dialog = false
      this.$emit('close')
    },
    deletePermission () {
      this.$store
        .dispatch('user/deletePartitionPermissions', { user: this.name })
        .then(() => {
          this.dialog = false
          this.$emit('success')
        })
    }
  },
  watch: {
    open (val) {
      this.dialog = val
    }
  }
}
</script>
